import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import LogoSimple from '../assets/Logo_simple.png';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  
  const handleNavigation = (sectionId: string) => {
    navigate(`/${sectionId}`);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-box">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={LogoSimple} alt="TERA" className="logo-image" />
            <p className="logo-tagline">Automatizar es avanzar. Innovar es crecer. Hacerlo sencillo es nuestra misión.</p>
          </div>
          <div className="footer-links">
            <h2>Secciones</h2>
            <button onClick={() => handleNavigation('inicio')} className="footer-link">Inicio</button>
            <button onClick={() => handleNavigation('nosotros')} className="footer-link">Nosotros</button>
            <button onClick={() => handleNavigation('soluciones')} className="footer-link">Soluciones</button>
            <button onClick={() => handleNavigation('equipo')} className="footer-link">Nuestro Equipo</button>
            <button onClick={() => handleNavigation('contacto')} className="footer-link">Contacto</button>
          </div>

          <div className="footer-links">
            <h2>Contacto</h2>
            <a href="mailto:ventas@teradev.mx">ventas@teradev.mx</a>
            <a href="tel:+525515957155">+52 55 1595 7155</a>
          </div>

          <div className="footer-links footer-social">
            <h2>Redes sociales</h2>
            <div className="social-icons">
              <a
                href="https://www.instagram.com/tera.mx_"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram de TERA"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/share/1DfAWYJdNK/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook de TERA"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        </div>
        <div className="footer-bottom">
          
          <div className="footer-info">
            <p>&copy; 2024 TERA. Todos los derechos reservados.</p>
          </div>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;